<template>
    <v-container>

        <v-row>
            <v-col cols="12" class="title-section">
                {{ $t('routines.lets_start') }}
            </v-col>
            <v-col cols="12" class="subtitle-section">
                {{ $t('routines.lets_start_subtext') }}
            </v-col>
            <v-col cols="12">
                <v-carousel :show-arrows="false" hide-delimiters vertical v-model="carousel" touchless height="110%">
                    <v-carousel-item v-for="(question, i) in questions" :key="question.value">
                        <v-row class="mx-auto">
                            <v-col cols="12" class="question-label">
                                {{ question.title }}
                                <br>
                                <v-icon class="mt-3" :color="colorIcon(question.value)" size="72">
                                    {{ question.icon }}
                                </v-icon>
                            </v-col>
                            <v-col v-for="option in question.options" :key="option.value" cols="12" md="6" offset-md="3" class="pa-1">
                                <v-btn
                                    block height="72" :outlined="isOutlinedBtn(question.value, option.value)"
                                    :color="colorBtn(option.value)" dark depressed class="container-btn"
                                    @click="nextCarousel(question.value, option.value)"
                                >
                                    <div class="text-btn">
                                        {{ option.text }} - {{ option.value }}
                                    </div>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-carousel-item>
                </v-carousel>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

import {db} from "@/utils/Firebase";

export default {
    name: "PreAssignedRoutine",
    props: {
        assignedRoutineId: {
            type: String,
            default: '',
        },
    },
    data(vm) {
        return {
            loading: false,
            routine: null,
            carousel: 0,
            sleep_night: null,
            muscles_hurt: null,
            tired: null,
            stressed: null,
            questions: [
                {
                    title: vm.$t('routines.how_sleep_last_night'),
                    icon: 'mdi-sleep',
                    value: 'sleep_night',
                    options: [
                        {value: 5, text: vm.$t('routines.sleepNightOptions.5')},
                        {value: 4, text: vm.$t('routines.sleepNightOptions.4')},
                        {value: 3, text: vm.$t('routines.sleepNightOptions.3')},
                        {value: 2, text: vm.$t('routines.sleepNightOptions.2')},
                        {value: 1, text: vm.$t('routines.sleepNightOptions.1')},
                    ]
                },
                {
                    title: vm.$t('routines.how_much_muscles_hurt'),
                    icon: 'mdi-arm-flex-outline',
                    value: 'muscles_hurt',
                    options: [
                        {value: 5, text: vm.$t('routines.musclesHurtOptions.5')},
                        {value: 4, text: vm.$t('routines.musclesHurtOptions.4')},
                        {value: 3, text: vm.$t('routines.musclesHurtOptions.3')},
                        {value: 2, text: vm.$t('routines.musclesHurtOptions.2')},
                        {value: 1, text: vm.$t('routines.musclesHurtOptions.1')},
                    ]
                },
                {
                    title: vm.$t('routines.how_tired_today'),
                    icon: 'mdi-flash-outline',
                    value: 'tired',
                    options: [
                        {value: 5, text: vm.$t('routines.tiredOptions.5')},
                        {value: 4, text: vm.$t('routines.tiredOptions.4')},
                        {value: 3, text: vm.$t('routines.tiredOptions.3')},
                        {value: 2, text: vm.$t('routines.tiredOptions.2')},
                        {value: 1, text: vm.$t('routines.tiredOptions.1')},
                    ]
                },
                {
                    title: vm.$t('routines.how_stressed_today'),
                    icon: 'mdi-brain',
                    value: 'stressed',
                    options: [
                        {value: 5, text: vm.$t('routines.stressedOptions.5')},
                        {value: 4, text: vm.$t('routines.stressedOptions.4')},
                        {value: 3, text: vm.$t('routines.stressedOptions.3')},
                        {value: 2, text: vm.$t('routines.stressedOptions.2')},
                        {value: 1, text: vm.$t('routines.stressedOptions.1')},
                    ]
                }
            ]
        }
    },
    methods: {
        start() {
            const vm = this
            vm.loading = true
            db.collection('assignedRoutines').doc(vm.assignedRoutineId).update({
                'advance.pre': true,
                'advance.preInfo': {
                    sleep_night: vm.sleep_night,
                    muscles_hurt: vm.muscles_hurt,
                    tired: vm.tired,
                    stressed: vm.stressed,
                }
            })
            vm.loading = false
            vm.$emit('complete')
        },
        nextCarousel(attribute, i) {
            const vm = this
            vm[attribute] = i
            vm.carousel === 3 ? vm.start() : vm.carousel++
        },
        colorIcon(attribute) {
            const vm = this
            return vm.getColor(vm[attribute])
        },
        colorBtn(value) {
            const vm = this
            return vm.getColor(value)
        },
        getColor(i) {
            switch (i) {
                case 1:
                    return '#cf919e'
                case 2:
                    return '#c27d71'
                case 3:
                    return '#E24F31'
                case 4:
                    return '#70A460'
                case 5:
                    return '#32b295'
            }
            return '#333333'
        },
        isOutlinedBtn(questionValue, optionValue) {
            const vm = this
            return vm[questionValue] !== optionValue
        }
    },
}
</script>

<style scoped>

.title-section {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
}

.subtitle-section {
    font-size: 15px;
    color: #707070;
}

.question-label {
    font-weight: bold;
    text-align: center;
    font-size: 15px;
    color: #333333;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.container-btn {
    border-width: 2px;
    border-radius: 8px;
}

.text-btn {
    white-space: normal;
    padding: 0 5px;
    font-size: 17px;
    font-weight: bold;
}

</style>
